export default "__VITE_ASSET__e1cd8b88__"